import Vue from 'vue';
export default Vue.extend({
    props: {
        numSteps: { type: Number, default: 1 },
        step: { type: Number, default: 1 }
    }
});
